// extracted by mini-css-extract-plugin
export default {"list":"privacyList_list__4IMVK","link":"privacyList_link__gvF5M","text":"privacyList_text__0lPX7"};